"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UIConfigSchema = exports.TaskSchema = void 0;
const zod_1 = require("zod");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
exports.TaskSchema = tape_sanitizer_1.StackTransformationSchema.omit({
    srcDataTape: true,
    otherDataTapes: true,
}).extend({
    operation: zod_1.z.literal('stack'),
    srcArtifactSlug: zod_1.z.string(),
    otherArtifactSlugs: zod_1.z.array(zod_1.z.string()),
});
exports.UIConfigSchema = exports.TaskSchema.omit({
    srcArtifactSlug: true,
    otherArtifactSlugs: true,
});
exports.nodeType = 'operation_stack';
//# sourceMappingURL=types.js.map